import script from "./ScoreBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreBox.vue?vue&type=script&setup=true&lang=js"

import "./ScoreBox.vue?vue&type=style&index=0&id=1cdbb4f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cdbb4f3"]])

export default __exports__